import {useAxiosClient} from "~/use/axios/client";
import {useOnline} from "@vueuse/core";
import {
    GmModelLibraryModelsProductModel,
    ProductApi
} from "~/gen/openapi/sblService";
import {keepPreviousData, useQuery, UseQueryOptions} from "@tanstack/vue-query";
import {MS_HOUR} from "~/constants/time";
import {queryClient} from "~/plugins/vue-query";

export const useProductService = () => {
    const { axiosClient } = useAxiosClient()
    const productApi = new ProductApi(undefined, '', axiosClient.value)
    const isOnline = useOnline()

    const productQueryOptions: UseQueryOptions<GmModelLibraryModelsProductModel[]> = {
        queryKey: ['productGetProducts'],
        queryFn: async () => {
            return (await productApi.productGetProducts())?.data
        },
        staleTime: MS_HOUR,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
        gcTime: Infinity,
        enabled: isOnline,
    }

    const productQuery = () => useQuery(productQueryOptions)

    const products = computed<GmModelLibraryModelsProductModel[]>(() => queryClient.getQueryData(productQueryOptions.queryKey) || [])

    return {
        productQueryOptions,
        productQuery,
        products,
    }
}